import { I18n } from 'react-redux-i18n';
import {
  CCLiteCommonFunc,
  calculatorFleetORAdditionalService,
  checkCompanyHasSupportPayment,
  checkCorporateUser,
  convertTravelerTypeToText,
  getLanguageAutoCompleteSearch,
  getServiceType,
  isAllDeliveryBookType,
  roundOff,
} from '../../../../src/utils/commonFunctions';
import {
  BOOK_TYPE,
  CODE_ERR_CORPORATE_PREPAID,
  PAYOUT_CUSTOM_TYPE,
  PAYOUT_TBD,
  PROVIDER_MAP_TYPE,
  REGULAR_MODE,
  STATUS_BEFORE_START,
  STATUS_BOOKING,
  STATUS_EXTENAL_INFO,
  STATUS_EXTENAL_INFO_TRANSFERZ,
  TRAVELER_TYPE,
  booking3rdPartyStatus,
  paymentMethodNumber,
  paymentMethodNumberFinished,
  thirdPartyIntegration,
} from '../../../constants/commondata';
import vehicle from '../../../containers/vehicle';
import { getChannelMap, getPositionInfomation } from '../../../utils/mapUtils';
import { KEY_BOOKER_CONTACT_VALID } from '../bookComponent/ContactInfo/component/BookerContact';
function onChangePickUpHour(e) {
  let value = e.target.value;
  if (this.state.data.time) {
    this.state.data.time.hour(value);
  }
  this.setState(
    {
      data: {
        ...this.state.data,
      },
    },
    () => {
      this.doPickupTimeChanged && this.doPickupTimeChanged();
      this.checkResetFlightApiWhenPickupTimeChange &&
        this.checkResetFlightApiWhenPickupTimeChange();
    },
  );
}

function onChangePickUpMin(e) {
  let value = e.target.value;
  if (this.state.data.time) {
    this.state.data.time.minute(value);
  }
  this.setState(
    {
      data: {
        ...this.state.data,
      },
    },
    () => {
      this.doPickupTimeChanged && this.doPickupTimeChanged();
      this.checkResetFlightApiWhenPickupTimeChange &&
        this.checkResetFlightApiWhenPickupTimeChange();
    },
  );
}

function onBookingDetailChangePickUpHour(e) {
  let value = e.target.value;
  if (this.state.data.request.pickUpTime) {
    this.state.data.request.pickUpTime.hour(value);
  }
  this.setState(
    {
      data: {
        ...this.state.data,
      },
    },
    () => {
      this.doPickupTimeChanged();
      this.checkResetFlightApiWhenPickupTimeChange &&
        this.checkResetFlightApiWhenPickupTimeChange();
    },
  );
}

function onBookingDetailChangePickUpMin(e) {
  let value = e.target.value;
  if (this.state.data.request.pickUpTime) {
    this.state.data.request.pickUpTime.minute(value);
  }
  this.setState(
    {
      data: {
        ...this.state.data,
      },
    },
    () => {
      this.doPickupTimeChanged();
      this.checkResetFlightApiWhenPickupTimeChange &&
        this.checkResetFlightApiWhenPickupTimeChange();
    },
  );
}

function handleCompanyDriverChange(e) {
  let newDriverCompany = {};
  this.state.driverCompany = null;
  this.state.data.request.companyId = '';
  [...this.props.commonData.companies, ...this.props.commonData.suppliers].map(
    (cp) => {
      if (cp._id == e.target.value) {
        newDriverCompany = cp;
        this.state.driverCompany = cp;
        this.state.data.request.companyId = cp._id;
        this.state.data.request.companyName = cp.name;
      }
    },
  );
  if (
    !checkCompanyHasSupportPayment(
      this.props.paymentMethod,
      newDriverCompany,
      this.state.data?.request?.paymentType,
    )
  ) {
    this.state.data.request.paymentType = 0;
  }
  this.setState(
    {
      driverCompany: this.state.driverCompany,
    },
    () => {
      this.carTypeBaseLocation().then((service) => {
        if (service.ok && service.res) {
          let cartypeSelected = null;
          // this.updateExtraServiceForEta(service, true)
          if (service.res.vehicleType && service.res.vehicleType.length > 0) {
            cartypeSelected = service.res.vehicleType.find((car) => {
              return (
                car.vehicleType == this.state.data.request.vehicleTypeRequest
              );
            });
            if (!cartypeSelected) {
              cartypeSelected = service.res.vehicleType[0];
              this.state.data.request.vehicleTypeRequest =
                cartypeSelected.vehicleType || cartypeSelected.ty;
            }
          }
          if (cartypeSelected != null) {
            //update vehicle type
            this.setState(
              {
                cartypeSelected,
              },
              () => {
                this.carTypeBaseLocation().then((res) => {
                  // if (this.updateExtraServiceForEta) {
                  //   this.updateExtraServiceForEta(res, true);
                  // }
                  this.etaFareCalculator();
                });
              },
            );
          } else {
            this.setState({
              cartypeSelected,
            });
          }
        }
      });
    },
  );
}

function handleDeliveryCompanyDriverChange(e) {
  let newDriverCompany = {};
  this.state.driverCompany = null;
  this.state.data.request.companyId = '';
  [...this.props.commonData.companies, ...this.props.commonData.suppliers].map(
    (cp) => {
      if (cp._id == e.target.value) {
        this.state.driverCompany = cp;
        this.state.data.request.companyId = cp._id;
        this.state.data.request.companyName = cp.name;
      }
    },
  );

  if (this.state.data.request.companyId) {
    const currencyMapping = this.mappingCurrency(
      this.state.data.request.companyId,
    );
    if (
      currencyMapping.currencyISO &&
      currencyMapping.currencyISO !==
        this.state.data?.request?.estimate?.fare?.currencyISO
    ) {
      _.set(
        this.state,
        'data.request.estimate.fare.supplierEarningType',
        'default',
      );
      _.set(this.state, 'data.request.estimate.fare.editedSupplierEarning', 0);
    }
  }

  this.setState(
    {
      driverCompany: this.state.driverCompany,
    },
    () => {
      this.carTypeBaseLocation().then((service) => {
        if (service.ok && service.res) {
          let cartypeSelected = null;
          if (service.res.vehicleType && service.res.vehicleType.length > 0) {
            let vehicleTypes = service.res.vehicleType.filter(
              (item) => item.delivery,
            );
            if (vehicleTypes.length) {
              cartypeSelected = vehicleTypes.find((car) => {
                return (
                  car.vehicleType == this.state.data.request.vehicleTypeRequest
                );
              });
              if (!cartypeSelected) {
                cartypeSelected = vehicleTypes[0];
                this.state.data.request.vehicleTypeRequest =
                  cartypeSelected.vehicleType || cartypeSelected.ty;
              }
            }
          }
          if (cartypeSelected != null) {
            //update vehicle type
            this.setState(
              {
                cartypeSelected,
              },
              () => {
                this.carTypeBaseLocation().then((res) => {
                  this.etaFareCalculator();
                });
              },
            );
          } else {
            this.state.data.request.estimate.fare = null;
            this.setState({
              cartypeSelected,
              etaFare: null,
              data: this.state.data,
            });
          }
        }
      });
    },
  );
}

export const convertParamAutocomplete = ({
  q,
  auth,
  sessiontoken,
  language,
  bookId,
  options = {},
}) => {
  const params = {
    input: q,
    fleetId: auth?.selectedFleet?.fleetId,
    sessiontoken,
    channel: getChannelMap(),
    forceProvider: auth?.selectedFleet?.generalSetting?.useTencentMapOnCC
      ? PROVIDER_MAP_TYPE.tencent
      : '',
    language: getLanguageAutoCompleteSearch(language?.locale),
    bookId,
    userId: auth?.user?._id,
    ...options,
  };
  return _.omitBy(params, _.isNil);
};

const checkResetDrvWhenChangeCompany = (
  companyIdDriver,
  companyIds = [],
  isBookDetail,
) => {
  if (isBookDetail) return true;
  if (
    !companyIdDriver ||
    companyIds?.length === 0 ||
    companyIds?.includes(companyIdDriver)
  )
    return false;
  return true;
};

const checkResetVehicleWhenChangeCompany = (
  vehicle,
  suppliers = [],
  isBookDetail,
) => {
  if (isBookDetail) return true;
  if (
    !vehicle?.vehicleId ||
    suppliers?.length === 0 ||
    suppliers?.includes(vehicle.companyId)
  )
    return false;
  return true;
};

export const getGoogleAddress = ({
  googleAddress,
  formattedAddress,
  suggestionAddress,
}) => {
  if (googleAddress === 0 && formattedAddress) return formattedAddress;
  return suggestionAddress || formattedAddress;
};

// #KAN-3415 we need to let the operator confirm the booking which has PAMM or PCAN status manually.
const confirmBooking3rdBookingStatus = (
  book,
  is3rdBooking,
  nameThirdParty,
  fleetSetting,
) => {
  if (!is3rdBooking) return false;

  // is HolidayTaxis
  if (nameThirdParty === thirdPartyIntegration.holidaytaxis) {
    const isAutoAccept = _.get(
      fleetSetting?.APIKeyFleetSettings?.find(
        (ob) => ob.appName === book.bookFrom,
      ),
      'thirdPartyIntegration.isAutoAccept',
      false,
    );
    if (
      !isAutoAccept &&
      [
        STATUS_EXTENAL_INFO.PAMM,
        STATUS_EXTENAL_INFO.PCAN,
        STATUS_EXTENAL_INFO.PCON,
      ].includes(book?.externalInfo?.status)
    ) {
      return true;
    }
  }

  // is TransferZ
  if (nameThirdParty === thirdPartyIntegration.transferZ) {
    const isAutoAcceptPA = _.get(
      fleetSetting?.APIKeyFleetSettings?.find(
        (ob) => ob.appName === book.bookFrom,
      ),
      'thirdPartyIntegration.isAutoAcceptPA',
      false,
    );

    if (
      !isAutoAcceptPA &&
      book?.externalInfo?.status === STATUS_EXTENAL_INFO_TRANSFERZ.PAMM
    ) {
      return true;
    }
  }

  // is Booking.com
  if (
    nameThirdParty === thirdPartyIntegration.bookingAPI ||
    nameThirdParty === thirdPartyIntegration.hoppa ||
    nameThirdParty === thirdPartyIntegration.klook ||
    nameThirdParty === thirdPartyIntegration.ctrip ||
    nameThirdParty === thirdPartyIntegration.dida ||
    nameThirdParty === thirdPartyIntegration.transferZ ||
    nameThirdParty === thirdPartyIntegration.fliggy || 
    nameThirdParty === thirdPartyIntegration.ctripv3
  ) {
    return book.status === booking3rdPartyStatus.allocated;
  }

  return false;
};

export const validateWhenUpdateCreateBook = ({ bookInfo, nameThirdParty }) => {
  // checkRequiredDispatch()

  /**
   * Booking Detail
   */

  // later book, Nếu đang có driver thì bắt buộc phải có vehicle
  if (
    [
      STATUS_BOOKING.booked,
      STATUS_BOOKING.arrived,
      STATUS_BOOKING.engaged,
    ].includes(bookInfo.status) &&
    bookInfo?.request.pickUpTime !== 'Now' &&
    !bookInfo?.vehicle?.plateNumber &&
    bookInfo?.drvInfo?.phone
  ) {
    return 'The vehicle is required';
  }

  if (
    nameThirdParty === thirdPartyIntegration.bookingAPI &&
    bookInfo.drvInfo.phone &&
    !bookInfo?.vehicle?.vehicleId
  ) {
    return 'The vehicle is required';
  }
  return '';
};

export const searchVehicles = (vehicles, textSearch) => {
  const results = [];
  const pattern = new RegExp(textSearch, 'i'); // 'i' for case-insensitive search

  vehicles.forEach((vehicle) => {
    const year = vehicle.year ? vehicle.year.toString() : '';
    const color = vehicle.color || '';
    const vehicleMake = vehicle.vehicleModel.vehicleMake || '';
    const vehicleModelName = vehicle.vehicleModel.name || '';

    if (
      pattern.test(year) ||
      pattern.test(color) ||
      pattern.test(vehicleMake) ||
      pattern.test(vehicleModelName)
    ) {
      results.push(vehicle);
    }
  });

  return results;
};

export const checkShowFare = ({ puPoints, doPoints, etaFare }) => {
  if (
    _.isEmpty(etaFare) ||
    puPoints?.length < 1
    // ||
    // (doPoints?.length < 1 && etaFare?.rateType !== 'hourly')
  )
    return false;

  return true;
};

export const showNotifyCancelEmailCheckbox = ({ bookInfo, auth }) => {
  if (checkCorporateUser(auth.user)) return false;
  const { enableCancelDelivery, enableCancelIntercity, enableCancelTransport } =
    auth?.selectedFleet?.settingSendEmail || {};
  if (isAllDeliveryBookType(bookInfo)) return enableCancelDelivery;
  if (getServiceType(bookInfo) === BOOK_TYPE.intercity)
    return enableCancelIntercity;
  return enableCancelTransport;
};

export function cancelBookingButtonClickCommon() {
  if (
    !this.state.showConfirmCancel &&
    (checkCorporateUser(this.props?.auth?.user) || this.state?.isHydraBooking)
  ) {
    this.props.loadingActions.showLoadingSpiner();
    this.props.bookingDetailActions
      .checkChargeCCCancel({
        fleetId: _.get(this.props.auth, 'selectedFleet.fleetId', ''),
        bookId: this.state.data.bookId,
      })
      .then((res) => {
        this.props.loadingActions.hideLoadingSpiner();
        if (res && res.returnCode === 200 && res.charge) {
          this.setState({
            msgWarningCancel: true,
            showConfirmCancel: !this.state.showConfirmCancel,
          });
        } else {
          this.setState({
            showConfirmCancel: !this.state.showConfirmCancel,
          });
        }
      });
  } else {
    this.setState({ showConfirmCancel: !this.state.showConfirmCancel });
  }
}

export const getVehicleWhenChangeDriver = ({
  oldVehicle,
  pickupTime,
  drvInfo,
  vehicleTypes,
  associateCarType = [],
}) => {
  if (pickupTime === 'Now') {
    return drvInfo?.vehicle || {};
  }

  // later book
  if (oldVehicle?.vehicleId) return oldVehicle;
  if (drvInfo?.vehicles?.length === 1) return drvInfo?.vehicles[0];

  // chọn xe default cua vehicleType của book later
  const vehicleDefault =
    (drvInfo?.vehicles || []).find(
      (vhc) => vehicleTypes.includes(vhc.vehicleType) && vhc.isDefault,
    ) || {};
  if (vehicleDefault?.vehicleType) return vehicleDefault;

  if (associateCarType?.length > 0) {
    // Nếu có duy nhất 1 vehicle default được asociate thì auto fill
    const vhcAssociatedDefault = drvInfo?.vehicles?.filter(
      (vhc) => associateCarType.includes(vhc.vehicleType) && vhc.isDefault,
    );
    if (
      vhcAssociatedDefault?.length === 1 &&
      vhcAssociatedDefault?.[0]?.vehicleType
    )
      return vhcAssociatedDefault[0];

    // Nếu có duy nhất 1 vehicle được asociate thì auto fill
    const vhcAssociatedNotDefault = drvInfo?.vehicles?.filter((vhc) =>
      associateCarType.includes(vhc.vehicleType),
    );
    if (
      vhcAssociatedNotDefault?.length === 1 &&
      vhcAssociatedNotDefault?.[0]?.vehicleType
    )
      return vhcAssociatedNotDefault[0];
  }

  return {};
};
export const resetVehicleWhenChangeDispatchType = ({
  pickupTime,
  currentVehicle,
  newDispatchType,
  isBookDetail,
}) => {
  if (pickupTime === 'Now') return {};
  if (isBookDetail && newDispatchType === 0) return {};
  return currentVehicle;
};

export const getFareWhenDroppedOff = ({ bookInfo, selectedFleet }) => {
  const droppedOffInfo = _.get(bookInfo, 'droppedOffInfo');
  let total = droppedOffInfo?.total || 0;
  if (droppedOffInfo?.isMinimum) {
    total = droppedOffInfo?.minimum;
  }
  if (selectedFleet?.rounding) {
    total = roundOff(total, bookInfo.currencyISO, selectedFleet.rounding);
  }
  return total;
};

export const getFareWhenInreview = ({ bookInfo, selectedFleet }) => {
  const inReviewInfo = _.get(bookInfo, 'inReviewRedis');
  let total = inReviewInfo?.total || 0;
  if (false) {
    total = inReviewInfo?.minimum;
  }
  if (selectedFleet?.rounding) {
    total = roundOff(total, bookInfo.currencyISO, selectedFleet.rounding);
  }
  return total;
};

export const convertPaymentTypeWhenBookCompleted = ({
  bookInfo,
  currentPayment,
}) => {
  if (
    CCLiteCommonFunc.isBookingStatusCompleted(bookInfo.status) &&
    !CCLiteCommonFunc.isDisplayCancelNoShowAmount(bookInfo)
  ) {
    if (bookInfo.completedInfo) {
      return CCLiteCommonFunc.paymentMappingCompletedToActive(
        bookInfo.completedInfo.paymentType,
      );
    }
  }
  return currentPayment;
};

export const getMsgCreateUpdateBook = (data = {}) => {
  let msg = '';
  if (
    data?.info?.chargedResult?.status === 'failed' &&
    CODE_ERR_CORPORATE_PREPAID.includes(data?.info?.chargedResult?.returnCode)
  ) {
    msg = I18n.t(
      `errors.completeBooking.${data?.info?.chargedResult?.returnCode}`,
    );
    return msg;
  }

  switch (data.errorCode) {
    case 'INVALID_GUEST_PHONE_NUMBER':
      msg = I18n.t('messages.booking.INVALID_GUEST_PHONE_NUMBER');
      break;
    case 'UNSUPPORTED_ZONE':
      msg = I18n.t('messages.booking.UNSUPPORTED_ZONE');
      break;
    case 'EXTERNAL_ID_EXISTED':
      msg = I18n.t('messages.booking.EXTERNAL_ID_EXISTED');
      break;
    case 'INVALID_VEHICLE':
      msg = 'Vehicle not supported';
      break;
    case 'INVALID_RECURRING_TIME':
      msg = 'Invalid recurring time range. Over maximum book ahead';
      break;
    case 'STOP_SALES_POLICY_VIOLATION':
      msg =
        'This booking cannot be completed due to a stop-sales policy violation.';
      break;
    default:
      if (data.overlapTime) {
        msg = I18n.t('messages.booking.driver_is_not_available');
      }
      break;
  }

  return msg;
};
// only use with edit fare flow
export const calculateFareWithTipChange = ({
  auth,
  data,
  promoInfo,
  etaFare: oldFare,
  tipPercent,
}) => {
  const tipAmount = (tipPercent * oldFare.subTotal) / 100;
  const editFare = {
    tip: tipAmount.toFixed(2),
  };
  return calculateFareWhenEdit({
    editFare: {
      ...oldFare,
      ...editFare,
    },
    changeFare: true,
    currency: auth?.selectedFleet?.currencies?.[0],
    selectedFleet: auth.selectedFleet,
    promoInfo,
    data,
    minFare: oldFare?.minFare || 0,
  });
};

// only use with edit fare flow
export const calculateFareWithServiceFeeChange = ({
  auth,
  data,
  promoInfo,
  etaFare: oldFare,
}) => {
  const editFare = {
    serviceFee: calculatorFleetORAdditionalService({
      services: data.extraServices,
      subTotal: oldFare.subTotal,
      currencyISO: etaFare?.currencyISO,
    }),
  };
  return calculateFareWhenEdit({
    editFare: {
      ...oldFare,
      ...editFare,
    },
    changeFare: true,
    currency: auth?.selectedFleet?.currencies?.[0],
    selectedFleet: auth.selectedFleet,
    promoInfo,
    data,
    minFare: oldFare?.minFare || 0,
  });
};

// only use with edit fare flow
export const calculateFareWithPromoChange = ({
  auth,
  data,
  promoInfo,
  etaFare: oldFare,
}) => {
  const editFare = {
    promoAmount: promoInfo?.value || 0,
  };
  return calculateFareWhenEdit({
    editFare: {
      ...oldFare,
      ...editFare,
    },
    changeFare: true,
    currency: auth?.selectedFleet?.currencies?.[0],
    selectedFleet: auth.selectedFleet,
    promoInfo,
    data,
    minFare: oldFare?.minFare || 0,
  });
};

const parseFloatValue = (value) => parseFloat(value) || 0;
const sumValues = (values) =>
  values.reduce((sum, value) => sum + parseFloatValue(value), 0);

export const getLocationWhenDrapEnd = ({
  results,
  id,
  callback,
  auth,
  language,
  bookId,
}) => {
  getPositionInfomation({
    latLng: results.latLng,
    callback: callback,
    id,
    auth: auth,
    language: getLanguageAutoCompleteSearch(language?.locale),
    bookId: bookId,
    isTencent: auth?.selectedFleet?.generalSetting?.useTencentMapOnCC,
  });
};

export const compareLocations = (oldLocation = [], newLocation = []) => {
  if (oldLocation?.length !== newLocation?.length) {
    return false;
  }

  return _.every(oldLocation, (item, index) => {
    return (
      item?.lat === newLocation[index]?.lat &&
      item?.lng === newLocation[index]?.lng
    );
  });
};

export const buildCustomerWithSelectedCorporate = (
  customer,
  selectedCorporate,
) => {
  const cus = { ...customer };
  let corporateId = cus.passengerInfo?.corporateId || cus.airlineId;
  let corporateInfo = cus.corporateInfo || {};

  selectedCorporate = selectedCorporate || {};
  // if (selectedCorporate.isAirline) {
  //   corporateId = cus.airlineId;
  //   corporateInfo = {
  //     assistantEmail: cus.assistantEmail,
  //     corpDivision: cus.corpDivision || '',
  //     corpId: cus.corpId,
  //     corpPO: cus.corpPO || '',
  //     costCentre: cus.costCentre,
  //     department: cus.department,
  //     managerEmail: cus.managerEmail,
  //     managerName: cus.managerName,
  //     title: cus.title,
  //   };
  // }

  return {
    ...cus,
    corporateSelectedInfo:
      corporateId === selectedCorporate._id
        ? {
            ...corporateInfo,
            division: corporateInfo.corpDivision,
          }
        : {},
  };
};

export const getDataCorporateChange = ({
  e,
  corporateCompany,
  paymentMethod,
  cartypeSelected,
}) => {
  const corpSelecting = corporateCompany.find((c) => c._id == e.target.value);
  if (corpSelecting) {
    let newCarTypeSelected = cartypeSelected || {};
    if (corpSelecting?.vehicleTypes?.type === 'customized') {
      const vhcIds = _.get(corp, 'vehicleTypes.value', []);
      if (!vhcIds.includes(carTypeSelected?._id)) newCarTypeSelected = null;
    }
    return {
      paymentMethod: corpSelecting.isAirline ? 5 : paymentMethod,
      isCustomerVip: corpSelecting.isCorporateVip || false,
      corporate: {
        ...corpSelecting,
        corporateId: corpSelecting?._id,
      },
      cartypeSelected: newCarTypeSelected,
    };
  }
  return {
    paymentMethod,
    cartypeSelected,
  };
};

export const filterPointEmpty = (points = []) => {
  if (points && points.length === 0) return [];
  return points.filter((ob) => !_.isEmpty(_.get(ob, 'address.address', '')));
};

export function checkLocationHasChange(newPoints) {
  const isSamePoints = compareLocations(
    this.state.lastPointsDirection,
    newPoints,
  );
  this.setState({
    lastPointsDirection: newPoints,
  });
  return !isSamePoints;
}

const calculateSubTotal = (
  basicFare,
  rushHourFee,
  otherFees,
  deliveryFee,
  serviceFee,
  isNewSettingAdditionFee,
  startingFee,
  moveFeeInJourney,
  waitFeeInJourney,
  mode,
) => {
  if (mode === REGULAR_MODE.timeOrMileage) {
    basicFare = Number(
      (
        (parseFloat(startingFee) || 0) +
        (parseFloat(moveFeeInJourney) || 0) +
        (parseFloat(waitFeeInJourney) || 0)
      ).toFixed(2),
    );
  }
  let subTotal = sumValues([basicFare, rushHourFee, otherFees, deliveryFee]);
  if (!isNewSettingAdditionFee) {
    subTotal += parseFloatValue(serviceFee);
  }
  return subTotal;
};

const calculateTax = (estEditedSubTotal, taxSetting, serviceTax) => {
  let tax =
    (parseFloatValue(estEditedSubTotal) * parseFloatValue(taxSetting)) / 100 ||
    0;
  tax += serviceTax || 0;
  return tax;
};

const calculateTotalWithoutPromo = (
  subTotal,
  airportFee,
  meetDriverFee,
  tollFee,
  parkingFee,
  gasFee,
  techFee,
  tip,
  bookingFee,
  tax,
  serviceFee,
  creditTransactionFee,
  isNewSettingAdditionFee,
) => {
  let totalWithoutPromo = sumValues([
    subTotal,
    airportFee,
    meetDriverFee,
    tollFee,
    parkingFee,
    gasFee,
    techFee,
    tip,
    bookingFee,
    tax,
    creditTransactionFee,
  ]);
  if (isNewSettingAdditionFee) {
    totalWithoutPromo += parseFloatValue(serviceFee);
  }
  return totalWithoutPromo;
};

const calculatePromoAmount = (subTotal, promoInfo) => {
  if (promoInfo?.type?.toLowerCase() === 'percent') {
    let promoAmount =
      (parseFloatValue(subTotal) * parseFloatValue(promoInfo.value)) / 100;
    if (promoInfo?.maximumValue?.isLimited && promoInfo?.maximumValue?.value) {
      promoAmount = Math.min(promoAmount, promoInfo.maximumValue.value);
    }
    return promoAmount || 0;
  } else {
    return promoInfo?.value || 0;
  }
};

export const calculateFareWhenEdit = ({
  editFare,
  changeFare,
  currency,
  selectedFleet,
  promoInfo = {},
  data,
  minFare,
}) => {
  if (!changeFare) {
    return _.cloneDeep(editFare);
  }

  if (editFare.mode === REGULAR_MODE.timeOrMileage) {
    editFare.basicFare = Number(
      (
        (parseFloat(editFare.startingFee) || 0) +
        (parseFloat(editFare.moveFeeInJourney) || 0) +
        (parseFloat(editFare.waitFeeInJourney) || 0)
      ).toFixed(2),
    );
  }

  const {
    basicFare,
    rushHourFee,
    otherFees,
    deliveryFee,
    serviceFee,
    taxSetting,
    airportFee,
    meetDriverFee,
    tollFee,
    parkingFee,
    gasFee,
    techFee,
    tip,
    bookingFee,
    creditTransactionFee,
    serviceTax,
    startingFee,
    moveFeeInJourney,
    waitFeeInJourney,
    mode,
  } = editFare;

  let estEdited = {
    ...editFare,
    subTotal: calculateSubTotal(
      basicFare,
      rushHourFee,
      otherFees,
      deliveryFee,
      serviceFee,
      data?.isNewSettingAdditionFee,
      startingFee,
      moveFeeInJourney,
      waitFeeInJourney,
      mode,
    ),
  };

  // const serviceFeeValue = calculatorFleetORAdditionalService(
  //   data.extraServices,
  //   estEdited.subTotal
  // )
  // estEdited.serviceFee = serviceFeeValue

  const tax = calculateTax(estEdited.subTotal, taxSetting, serviceTax);
  estEdited.tax = tax;

  estEdited.promoAmount = calculatePromoAmount(estEdited.subTotal, promoInfo);

  estEdited.totalWithoutPromo = calculateTotalWithoutPromo(
    estEdited.subTotal,
    airportFee,
    meetDriverFee,
    tollFee,
    parkingFee,
    gasFee,
    techFee,
    tip,
    bookingFee,
    tax,
    serviceFee,
    creditTransactionFee,
    data.isNewSettingAdditionFee,
  );

  let total = sumValues([
    estEdited.subTotal,
    airportFee,
    meetDriverFee,
    tollFee,
    parkingFee,
    gasFee,
    techFee,
    tip,
    bookingFee,
    tax,
    -estEdited.promoAmount,
    creditTransactionFee,
  ]);

  if (data.isNewSettingAdditionFee) {
    total += parseFloatValue(serviceFee);
  }

  if (promoInfo && promoInfo.keepMinFee && total < minFare) {
    total = minFare;
    estEdited.isMinimumTotal = true;
  } else {
    estEdited.isMinimumTotal = false;
  }

  const totalRoundOff = roundOff(total, currency.iso, selectedFleet.rounding);
  estEdited.etaFare = !totalRoundOff || totalRoundOff < 0 ? 0 : totalRoundOff;
  estEdited.totalOrder = estEdited.etaFare;

  return estEdited;
};

export const checkRequiredDispatch = ({
  dispatchType,
  isBookNow,
  driverPhone,
  vehicleId,
  isShuttle,
}) => {
  if ((dispatchType === 1 || dispatchType === 3) && !driverPhone) {
    return true;
  }
  return false;
};

export const calculatePayout = ({
  driverInfo,
  companyIdsSelected,
  companiesInfo,
  etaFare,
  bookType,
  fareSettings,
  selectedFleet,
}) => {
  // multiple Agent/Supplier: Payout = TBD
  if (
    !companyIdsSelected ||
    companyIdsSelected?.length > 1 ||
    companyIdsSelected?.length === 0
  )
    return PAYOUT_TBD;

  // case 1 supplier/agent
  if (companyIdsSelected?.length === 1) {
    const { etaFare: total = 0 } = etaFare;
    const companyInfo = companiesInfo.find(
      (c) => c._id === companyIdsSelected[0],
    );

    // agent
    if (companyInfo?.type === 'company') {
      if (driverInfo?.phone) {
        const fleetCommission = calculatorFleetCommission({
          fareSettings,
          bookType,
          driverInfo,
          selectedFleet,
          etaFare: etaFare,
        });
        let serviceFee =
          selectedFleet?.additionalFees === 1
            ? etaFare.fleetCommissionFromFleetServiceFee
            : 0;
        const subFare =
          (parseFloat(serviceFee) || 0) +
          (parseFloat(etaFare.techFee) || 0) +
          (parseFloat(etaFare.creditTransactionFee) || 0) +
          (parseFloat(etaFare.markupDifference) || 0) -
          (parseFloat(etaFare.promoAmount) || 0);
        // 'Total - fleet commission x subtotal - all fee by to fleet'
        return total - (fleetCommission || 0) - subFare;
      }
      return PAYOUT_TBD;
      // case supplier
    } else {
      const supplierCommission = calculatorSupplierCommission({
        bookType,
        etaFare: etaFare,
        supplierInfo: companyInfo,
      });
      // 'Total - (Subtotal * Fleet commission(setting on Supplier profile) / 100)'
      return total - (supplierCommission || 0);
    }
  }
};

const valFareCalculation = (editFare, fleetSetting) => {
  const commissionBasedOnTotalFare =
    fleetSetting?.fleetDeduction?.commissionBasedOnTotalFare;
  return commissionBasedOnTotalFare
    ? parseFloatValue(editFare.totalWithoutPromo)
    : parseFloatValue(editFare.subTotal);
};

export const checkShowAllVehicleBtn = (booking) => {
  if (
    check3RDBooking(booking) ||
    !booking.bookId ||
    !STATUS_BEFORE_START.includes(booking.status)
  )
    return false;
  return true;
};

export const check3RDBooking = (booking) => {
  return [
    thirdPartyIntegration.bookingAPI,
    thirdPartyIntegration.holidaytaxis,
    thirdPartyIntegration.karhoo,
    thirdPartyIntegration.hoppa,
    thirdPartyIntegration.klook,
    thirdPartyIntegration.ctrip,
    thirdPartyIntegration.ctripv3,
    thirdPartyIntegration.dida,
    thirdPartyIntegration.transferZ,
    thirdPartyIntegration.fliggy,
    thirdPartyIntegration.etg,
  ].includes(booking?.externalInfo?.thirdParty); // is booking from Third Party: Booking, Mozio, Karhoo, Hoppa, Klook
};

export const getAllPointNotEmpty = ({
  puPoints = [],
  doPoints = [],
  roundTrip,
}) => {
  const puPointsNotEmpty = filterPointEmpty(puPoints),
    doPointsNotEmpty = filterPointEmpty(doPoints);
  let points = [];
  if (puPointsNotEmpty.length > 0 || doPointsNotEmpty.length > 0) {
    puPointsNotEmpty.forEach((point) => {
      let geo = point?.address?.geo || [];
      if (_.isEmpty(geo)) return;
      points.push({
        lat: geo[1],
        lng: geo[0],
      });
    });
    doPointsNotEmpty.forEach((point) => {
      let geo = point?.address?.geo || [];
      if (_.isEmpty(geo)) return;
      points.push({
        lat: geo[1],
        lng: geo[0],
      });
    });
    if (roundTrip && puPointsNotEmpty[0]) {
      let geo = puPointsNotEmpty?.[0]?.address?.geo || [];
      points.push({
        lat: geo[1],
        lng: geo[0],
      });
    }
  }
  return points;
};

export const convertValueBasedOnCurrency = ({
  value,
  fromCurrencyExchangeRate,
  toCurrencyExchangeRate,
}) => {
  if (fromCurrencyExchangeRate === toCurrencyExchangeRate) return value;
  if (!fromCurrencyExchangeRate || !toCurrencyExchangeRate) return 0;
  return value * (toCurrencyExchangeRate / fromCurrencyExchangeRate);
};

export const convertSupplierPayoutValueBasedOnCurrency = ({
  currencyFleet,
  payoutValue,
  currencySupplier,
  currenciesExchangeRate,
}) => {
  if (currencyFleet === currencySupplier) return payoutValue;

  const fleetExchangeRate = currenciesExchangeRate?.find(
    (c) => c.iso === currencyFleet,
  )?.exchangeRate;
  const supplierExchangeRate = currenciesExchangeRate?.find(
    (c) => c.iso === currencySupplier,
  )?.exchangeRate;

  return convertValueBasedOnCurrency({
    value: payoutValue,
    fromCurrencyExchangeRate: fleetExchangeRate,
    toCurrencyExchangeRate: supplierExchangeRate,
  });
};

export function calculatorPayoutWhenCustom({
  editFare = {},
  currencySupplier,
  currenciesExchangeRate,
}) {
  if (_.isEmpty(editFare)) return 0;

  let payoutValue = 0;
  if (editFare.supplierEarningType === PAYOUT_CUSTOM_TYPE.amount)
    payoutValue = parseFloatValue(editFare.editedSupplierEarning);

  if (editFare.supplierEarningType === PAYOUT_CUSTOM_TYPE.percent)
    payoutValue =
      (parseFloatValue(editFare.etaFare) *
        parseFloatValue(editFare.editedSupplierEarning)) /
      100;

  if (editFare.supplierEarningType === PAYOUT_CUSTOM_TYPE.default) {
    payoutValue = editFare?.totalPayout || 0;
  }
  const currencyFleet = editFare?.currencyISO;
  if (
    currencySupplier &&
    currencyFleet !== currencySupplier &&
    editFare.supplierEarningType === PAYOUT_CUSTOM_TYPE.percent
  ) {
    payoutValue = convertSupplierPayoutValueBasedOnCurrency({
      currencyFleet,
      payoutValue,
      currencySupplier,
      currenciesExchangeRate,
    });
  }
  return payoutValue;
}

export const hideSupplierCorpBoard = (user, selectedFleet) => {
  if (checkCorporateUser(user)) {
    return selectedFleet?.generalSetting?.hideProviderFromCorp;
  }
  return false;
};

export const calculatorFleetCommission = ({
  fareSettings,
  driverInfo,
  bookType,
  selectedFleet,
  etaFare,
}) => {
  const differentFleetCommission = _.get(
    selectedFleet,
    'generalSetting.differentFleetCommission',
    false,
  );
  let fleetCommissionValue = 0;

  const driver = _.get(driverInfo, 'driverId.driverInfo', {});
  // custome commission based service
  if (differentFleetCommission) {
    let fleetCommissionObj = {};

    // get fleetCommission by setting fleet
    fleetCommissionObj = _.find(
      _.get(fareSettings, `fare.fleetCommission`, []),
      (ob) => ob.serviceType === bookType,
    );

    // check driver has customize fleet commission
    if (
      !_.isEmpty(driver) &&
      driver.commissionDriverType === 'customize' &&
      driver.commissionDriverValue &&
      driver.commissionDriverValue.length > 0
    ) {
      fleetCommissionObj = _.find(
        _.get(driver, 'commissionDriverValue', []),
        (ob) => ob.serviceType === bookType,
      );
    }

    if (!_.isEmpty(fleetCommissionObj)) {
      fleetCommissionValue = fleetCommissionObj.value;
      if (fleetCommissionObj.type === 'percent') {
        fleetCommissionValue = (etaFare.subTotal * fleetCommissionValue) / 100;
      }
    }
  } else {
    const driver = _.get(driver, 'driverId.driverInfo', {});
    const commissionValue = _.get(
      driver,
      'commissionByCurrencies[0].commissionValue',
      0,
    );
    if (!_.isEmpty(driver) && commissionValue > 0) {
      fleetCommissionValue = commissionValue;
      if (driver.commissionType === 'percent') {
        fleetCommissionValue = (etaFare.subTotal * commissionValue) / 100;
      }
    }
  }

  return fleetCommissionValue;
};

export const calculatorSupplierCommission = ({
  supplierInfo,
  bookType,
  etaFare,
}) => {
  let commissionFinal = supplierInfo.commissionValue || 0;

  if (supplierInfo?.commissionCompanyType === 'customize') {
    const commissionCustom = _.find(
      supplierInfo.commissionCompanyValue,
      (ob) => ob.serviceType === bookType,
    );
    if (!_.isEmpty(commissionCustom)) commissionFinal = commissionCustom.value;
  }

  return (etaFare.subTotal * commissionFinal) / 100;
};

export const checkRoundTrip = ({ fare = {}, locationService = {} }) => {
  if (!fare?.normalFare) return false;
  const routeExists = (fare?.route || '').trim().length > 0;

  return (
    routeExists && (locationService?.roundTrip || locationService?.crossZone)
  );
};

// delivery, transport, intercity
export const validateCreateBookCommon = ({
  travelerType,
  corpId,
  valid = {},
}) => {
  let info = {
    isValid: true,
    msgErr: '',
  };

  // clone booking: Tạo book có corp, sau đó corp bị remove. #KAN-4006
  if (travelerType === 1 && !corpId) {
    info.msgErr = 'Please select a corporate';
    info.isValid = false;
    return info;
  }

  if (valid[KEY_BOOKER_CONTACT_VALID] === false) {
    info.msgErr = I18n.t('messages.booking.contact_info_required');
    info.isValid = false;
  }

  return info;
};

export const resetPaymentWhenChangeTravelerType = ({
  paymentByType,
  oldPayment,
  isShuttle,
}) => {
  let newPm = oldPayment,
    setValidate = false;
  if (!paymentByType?.find((card) => card.value == oldPayment)) {
    const paymentFirst = paymentByType?.[0]?.value;
    newPm = paymentFirst;
    if ((paymentFirst == 6 || paymentFirst == 5) && isShuttle) {
      setValidate = true;
    }
  }
  return {
    newPm,
    setValidate,
  };
};

export const buildCorporateParamToCreateBook = ({
  corporateInfo,
  corporateUserInfo,
  paymentMethod,
  credit,
  clientCaseMatter,
  chargeCode,
}) => {
  if (!corporateInfo?._id) return {};
  let corpObj = {
    division: corporateUserInfo?.division,
    managerEmail: corporateUserInfo?.managerEmail,
    managerName: corporateUserInfo?.managerName,
    costCentre: corporateUserInfo?.costCentre,
    department: corporateUserInfo?.department,
    corpId: corporateUserInfo?.corpId,
    corporateId: corporateInfo?._id,
    name: corporateInfo?.companyInfo?.name ?? corporateInfo?.companyName,
    clientCaseMatter: clientCaseMatter,
    chargeCode: chargeCode,
  };

  if (
    paymentMethod == paymentMethodNumber.corporateCard &&
    credit?.cardHolder
  ) {
    corpObj = {
      ...corpObj,
      creditInfo: {
        cardHolder: credit.cardHolder,
        cardType: credit.cardType,
        gateway: credit.gateway,
        localToken: credit.localToken,
        crossToken: credit.crossToken,
        cardMask: credit.cardMask,
      },
    };
  }

  if (paymentMethod == 4 || paymentMethod == 5 || paymentMethod == 7) {
    corpObj = {
      ...corpObj,
      clientCaseMatter: '',
      chargeCode: '',
    };
  }
  return corpObj;
};

export const getTravelerTypeTextCommon = ({ travelerType, coporateInfo }) => {
  const travelerTypeText = travelerType == 0 ? 'individual' : 'corporation';
  const isAirlineCorporate = coporateInfo?.isAirline || false;
  return convertTravelerTypeToText(travelerTypeText, isAirlineCorporate);
};
export {
  onChangePickUpHour,
  onChangePickUpMin,
  onBookingDetailChangePickUpHour,
  onBookingDetailChangePickUpMin,
  handleCompanyDriverChange,
  handleDeliveryCompanyDriverChange,
  checkResetDrvWhenChangeCompany,
  confirmBooking3rdBookingStatus,
  checkResetVehicleWhenChangeCompany,
};
